<tui-textfield class="input-code" tuiTextfieldSize="l">
  <input id="inputCode" tuiInputPin [maxlength]="codeLength" [formControl]="codeControl" />
</tui-textfield>
